import React from 'react';
import NewsletterSignup from '../../components/NewsletterSignup';

const IndexPage = () => (
  <div>
    <div className="mw9 center">
      <h1>Live longer</h1>
      <p className="f3 i">Guide coming soon</p>
      <NewsletterSignup />
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/goals/live-longer.js